import { siteConfig } from '@/config/site'

export const formatNumber = (num: number | undefined = 0) => {
  return num?.toLocaleString('en-US')
}

const maximumFractionDigits = 2
const minimumFractionDigits = 2

export const formatCurrency = (value: number | undefined = 0) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits,
    maximumFractionDigits,
  })
    .format(value)
    .replace('$', 'USD $ ')
}

export const formatDecimal = (value: number | undefined = 0) => {
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value)
}

export const getAssetUrl = (path: string): string => {
  // 如果已經是完整的 URL（包括 blob URL），直接返回
  if (
    path.startsWith('http://') ||
    path.startsWith('https://') ||
    path.startsWith('blob:')
  ) {
    return path
  }

  // 確定基礎 URL
  let baseUrl: string

  if (typeof window !== 'undefined' && siteConfig.isDynamicDomain) {
    // 客戶端且啟用動態域名
    const { hostname } = window.location
    const domain = hostname.match(/[^.]+\.[^.]+$/)?.[0] || 'mfans.live'
    baseUrl = `https://images.${domain}/web`
  } else {
    // 服務器端或未啟用動態域名
    baseUrl = 'https://images.mfans.live/web'
  }

  // 確保路徑以 / 開頭
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${baseUrl}${normalizedPath}`
}
